import Inspector from "components/app/vessel/onboard/inspector/Inspector";
import React from "react";
import { useParams } from "react-router-dom";

type ScreenVesselOnboardInspectorType = React.PropsWithChildren<{}>;
const ScreenVesselOnboardInspector: React.FC<ScreenVesselOnboardInspectorType> = (
	props: ScreenVesselOnboardInspectorType
) => {
	const params = useParams<{vesselId: string}>();
	return <Inspector vesselId={params.vesselId} />;
};

export default ScreenVesselOnboardInspector;
